<template>
    <div class="flex items-center space-x-4 py-5 px-4 sm:px-6"
    >
<!--        <div class="flex-shrink-0 text-primary-500 self-start">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5"
                 fill="none"
                 viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                      stroke-width="2"
                      d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"/>
            </svg>
        </div>-->
        <div class="flex-1 min-w-0">
            <div class="text-xs flex text-gray-400 mb-2 w-full">
                <div class="flex items-center pr-3">
                    <CalendarIcon class="h-3 w-3 text-gray-300 mr-1" aria-hidden="true"/>
                    <span>{{ file.readable_creation_date }}</span>
                </div>
                <div class="flex items-center">
                    <DocumentIcon class="h-3 w-3 text-gray-300 mr-1" aria-hidden="true"/>
                    <span>{{ file.readable_file_size }} MB</span>
                </div>
                <div class="flex items-center ml-auto" v-if="$page.props.auth.user.is_superuser || mutationDisabled">
                    <MailIcon class="h-4 w-4 text-secondary-100 mr-1" aria-hidden="true" v-if="!file.read_at" :title="$t('Unread')" />
                    <MailOpenIcon class="h-4 w-4 text-gray-300 mr-1" aria-hidden="true" v-else :title="$t('Read')" />
                </div>
            </div>
            <a target="_blank" :href="file.download_url" class="flex font-bold text-gray-900 truncate text-primary-500">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
                {{ visibleName }}
            </a>
            <div class="mt-2 text-sm text-gray-500 truncate">
                <form @submit.prevent="submitDescriptionForm">
                    <!--<jet-label :for="`file_${file.hash}_description`" value="Bemerkungen zur Datei"/>-->
                    <jet-text-area rows="1" :id="`file_${file.hash}_description`" type="text"
                                   class="mt-1 block w-full text-sm" :placeholder="$t('File note(s)')"
                                   v-model="form.description" :disabled="isImmutable"/>
                    <div class="pt-3 flex items-center justify-end"
                         v-if="(file.description != form.description) && !isImmutable">

                        <jet-secondary-button @click="form.reset()" :disabled="form.processing">
                            {{ $t('Cancel') }}
                        </jet-secondary-button>

                        <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                            {{ $t('Saved.') }}
                        </jet-action-message>

                        <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                            {{ $t('Save') }}
                        </jet-button>
                    </div>
                </form>
            </div>
        </div>
        <div class="flex flex-col" v-if="!isImmutable">
            <a
                href="#"
                @click.prevent="deleteFile(file)"
                class="pl-2 sm:pl-4 py-1 text-sm leading-5 font-medium text-danger-700 hover:text-danger-400">
                <template v-if="!isLoading">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5"
                         fill="none"
                         viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round"
                              stroke-width="2"
                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                    </svg>
                </template>
                <template v-else>
                    <svg xmlns="http://www.w3.org/2000/svg" class="animate-spin h-5 w-5" fill="none" viewBox="0 0 24 24"
                         stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
                    </svg>
                </template>
            </a>
        </div>
    </div>
</template>

<script setup>
import {CalendarIcon, ScaleIcon, DocumentIcon} from '@heroicons/vue/solid'
import {MailIcon, MailOpenIcon} from '@heroicons/vue/outline'
</script>

<script>

import JetLabel from "@/Jetstream/Label";
import JetTextArea from "@/Jetstream/Textarea";
import JetActionMessage from "@/Jetstream/ActionMessage";
import JetButton from "@/Jetstream/Button";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";

export default {
    name: "FileContainerFile",
    components: {
        JetLabel,
        JetTextArea,
        JetActionMessage,
        JetButton,
        JetSecondaryButton,
    },
    props: {
        file: Object,
        mutationDisabled: Boolean,
        // Optional label chosen by the parent - the invoices/reports layout prefixes the month.
        // Never write to file.name to achieve that: it is a shared Inertia page prop.
        displayName: String,
    },
    computed: {
        visibleName() {
            return this.displayName || this.file.name;
        },
        isImmutable() {
            return (this.file.is_readonly && !(this.$page.props.auth.user.is_superuser)) || (this.mutationDisabled);
        }
    },
    data() {
        return {
            isLoading: false,
            form: this.$inertia.form({
                description: this.file.description,
            })
        };
    },
    methods: {
        submitDescriptionForm() {
            this.form.put(route('files.update', {file: this.file.hash}), {
                preserveScroll: true,
                preserveState: false,
                onSuccess: () => {
                    this.form.clearErrors();
                    this.form.description = this.file.description;
                },
            })
        },
        deleteFile(file) {
            if (!this.isImmutable && !this.isLoading) {
                this.$inertia.delete(route('files.destroy', {file: file.hash}), {
                    preserveScroll: true,
                    preserveState: false,
                    onStart: () => (this.isLoading = true),
                    onFinish: () => (this.isLoading = false),
                })
            }
        }
    },
}
</script>

<style scoped>

</style>
